import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { ToastrModelService } from '../toastr-model.service';

const BLOCKED_ERROR_MESSAGE: string[] = [
  'No consultant found',
  'Admin doest not exits',
  'Argument passed in does not match the accepted types'
];

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  public toastr: ToastrModelService = inject(ToastrModelService);
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        const errorMessage = err.error.error?.message || err?.error?.error.message;
        if (errorMessage) {
          if (typeof errorMessage === 'string') {
            if (!this.isPlainText(errorMessage)) return throwError(() => err);
            if (BLOCKED_ERROR_MESSAGE.map(err => err.toLowerCase()).includes(errorMessage.toLowerCase())) return throwError(() => err);
            this.toastr.error(this.toSentenceCase(errorMessage));
          } else if (typeof errorMessage === 'object') {
            if (typeof errorMessage.message === 'string') {
              if (!this.isPlainText(errorMessage.message)) return throwError(() => err);
              if (BLOCKED_ERROR_MESSAGE.map(err => err.toLowerCase()).includes(errorMessage.message.toLowerCase())) return throwError(() => err);
              this.toastr.error(this.toSentenceCase(errorMessage.message));
              return throwError(() => err);
            }

            const message = errorMessage.error.map(error => {
              const rawMsg = error?.message ?? 'Validation error';
              const value = error?.context?.value ?? 'value';
              return `${rawMsg.replace(/\".*?\"/, `"${value}"`)}`;
            }).join('\n');

            if (!this.isPlainText(message)) return throwError(() => err);
            if (BLOCKED_ERROR_MESSAGE.map(err => err.toLowerCase()).includes(message.toLowerCase())) return throwError(() => err);
            this.toastr.error(this.toSentenceCase(message));
          }
        }
        return throwError(() => err);
      })
    );
  }

  private isPlainText(input: string): boolean {
    const specialCharPattern = /[{}[\]<>\/\\|#$%^&*()?+=~]/;
    return input.trim().length > 0 && !specialCharPattern.test(input);
  }

  private toSentenceCase(input: string): string {
    const trimmed = input.trim();
    if (!trimmed) return '';
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  }


}
